import { render, staticRenderFns } from "./AdminTabsLayers.vue?vue&type=template&id=36e406fe&scoped=true&"
import script from "./AdminTabsLayers.vue?vue&type=script&lang=js&"
export * from "./AdminTabsLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e406fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTabItem})
